import { environment } from './../../../../environments/environment';
import { SigninComponent } from './../signin/signin.component';
import { MatDialog } from '@angular/material/dialog';
import { ALSUPER_LIST, LIVESUPER_LIST, HELP_LIST, CORP_LIST, ALLIES_LIST, FOOTER_LIST_MOBILE, JOIN_THE_TEAM_LIST } from '../../utils';
import { Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CedisModalComponent } from '../cedis-modal/cedis-modal.component';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { OrderService } from '@services/order.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss'],
  standalone: true,
  imports: [MatIconModule, RouterLink, MatButtonModule, MatFormFieldModule, MatExpansionModule, MatDividerModule, TranslateModule, NgOptimizedImage]
})
export class HomeFooterComponent implements OnInit, OnDestroy {

  public footerListMobile = FOOTER_LIST_MOBILE;
  public alsuperList = ALSUPER_LIST;
  public liveList = LIVESUPER_LIST;
  public alliesList = ALLIES_LIST;
  public joinList = JOIN_THE_TEAM_LIST;
  public helpList = HELP_LIST;
  public corpList = CORP_LIST;
  public onMobile: boolean;
  public innerWidth: any;
  public panelOpenState = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
    }
    this.onMobile = this.innerWidth < 900 ? true : false;
  }
  public token: string;

  public appStoreUrl = environment.appStore;
  public googlePlayUrl = environment.googlePlay;
  public year = new Date().getFullYear();

  public version = environment.version;

  private subs = new Subject<void>();
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private router: Router,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: string,
    private orderService: OrderService
  ) {
    if (this.isBrowser) this.token = JSON.parse(localStorage.getItem('token') || '{}').jwt;
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.innerWidth = window.innerWidth;
      this.onMobile = this.innerWidth < 900 ? true : false;
    }

    //* Suscripción al observable 'refreshHome$' para refrescar los datos de la vista.
    this.orderService.refreshHome$.pipe(takeUntil(this.subs)).subscribe((res: boolean) => {
      if (res) {
        if (this.isBrowser) this.token = JSON.parse(localStorage.getItem('token') || '{}').jwt;
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

  public onNavigate(route: string): void {
    if (route.includes('http')) {
      window.open(route, '_blank');
    } else {
      switch (route) {
        case 'listas-alsuper':
          if (this.token) {
            this.router.navigate([route]);
            if (isPlatformBrowser(this.platformId)) {
              window.scroll(0, 0);
            }
          } else {
            this.dialog.open(SigninComponent, { autoFocus: false });
          }
          break;
        default:
          if (isPlatformBrowser(this.platformId)) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
          break;
      }
    }
  }

  public navigationLanding(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
    this.router.navigate(['/alsuperapp']);
  }

  public openCEDISModal(): void {
    this.dialog.open(CedisModalComponent, {
      autoFocus: false,
      width: '600px'
    });
  }
}
